import { render, staticRenderFns } from "./SudoImage.vue?vue&type=template&id=0ff573b6&"
import script from "./SudoImage.vue?vue&type=script&lang=js&"
export * from "./SudoImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports